import { render } from "./couponsComponent.vue?vue&type=template&id=addef1dc&scoped=true"
import script from "./couponsComponent.vue?vue&type=script&lang=js"
export * from "./couponsComponent.vue?vue&type=script&lang=js"

import "./couponsComponent.vue?vue&type=style&index=0&id=addef1dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-addef1dc"]])

export default __exports__